import { gql } from "@apollo/client";
export const ADMIN_WINERY_MEMBER_UPDATE = gql `
  mutation AdminWineryMemberUpdate($input: AdminWineryMemberUpdateInput!) {
    AdminWineryMemberUpdate(input: $input)
  }
`;
